import React, { useContext, useRef, useState } from "react";
import axios from "axios";
import { CanvasContext, ICanvasComponent } from "../canvasContext.tsx";
import { basicURL } from "../../apiManager/APIConfig";
import { store } from "../../redux/store";

const VideoElement = (props: ICanvasComponent) => {
  const { content, id } = props;
  const { actions, uploadEntity } = useContext(CanvasContext);
  const inputRef = useRef<HTMLInputElement>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const uploadToBackend = async (file: File): Promise<string | null> => {
    if (!uploadEntity) return null;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("entity_type", uploadEntity.entity_type);
    formData.append("entity_id", uploadEntity.entity_id);
    formData.append("destination", "presentation");
    formData.append("folder_name", "presentation");
    const token = store.getState().auth?.access_token;
    const res = await axios.post(`${basicURL}file/upload`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res?.data?.download_url || null;
  };

  const handleUrlBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const url = e.target?.value?.trim();
    if (url) {
      actions?.updateCanvasData({ id, content: url });
      actions?.saveNow?.();
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target?.files?.[0];
    if (!file || !uploadEntity) return;
    setUploading(true);
    try {
      const url = await uploadToBackend(file);
      if (url) {
        actions?.updateCanvasData({ id, content: url });
        actions?.saveNow?.();
      }
    } catch (err) {
      console.error("Video upload error:", err);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  if (!content) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#f0f0f0",
          borderRadius: 4,
          padding: 8,
        }}
      >
        <span style={{ fontSize: 12, marginBottom: 8 }}>Video URL or upload</span>
        <input
          ref={inputRef}
          type="url"
          placeholder="Paste video URL..."
          style={{ width: "100%", padding: 4, fontSize: 12, marginBottom: 8 }}
          onBlur={handleUrlBlur}
        />
        {uploadEntity && (
          <>
            <input
              ref={fileRef}
              type="file"
              accept="video/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <button
              type="button"
              style={{ fontSize: 12, padding: "4px 8px" }}
              onClick={() => fileRef.current?.click()}
              disabled={uploading}
            >
              {uploading ? "Uploading…" : "Upload video"}
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100%", background: "#000" }}>
      <video
        src={content}
        controls
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        muted
        loop
        playsInline
      />
    </div>
  );
};

export default VideoElement;
